<template>
  <div class="container">
    <div class="row" @keydown.enter.prevent="search">
      <base-input wrapper-class="form-group mb-2" class="col-12 col-md-8 mt-2">
        <input type="text" class="form-control" v-model="filter.name" placeholder="Informe o nome do usuário"
          aria-describedby="button-addon2" />
      </base-input>
      <base-input wrapper-class="form-group mb-2" class="col-12 col-md-4 mt-2">
        <multiselect v-model="selectedRole" :options="roles" placeholder="Selecionar Papel"
          label="name" track-by="id" style="width: 100%" />
      </base-input>
      <base-input wrapper-class="form-group mb-2" class="col-12 col-md-4 mt-2">
        <base-switch v-model="active" label="Usuários Ativos"></base-switch>
      </base-input>
      <base-input wrapper-class="form-group mb-2" class="col-12 col-md-8 mt-2">
        <div class="input-group-append row justify-content-end pr-3">
          <base-button class="col-12 col-md-auto mb-2 ml-3" outline type="success" @click="clearSearch">Limpar Pesquisa</base-button>
          <base-button class="col-12 col-md-auto mb-2 ml-3" type="success" @click="search">Pesquisar</base-button>
          <base-button class="col-12 col-md-auto mb-2 ml-3" type="info" @click="newUser" size="sm">Novo Usuário</base-button>
        </div>
      </base-input>
    </div>
    <!-- Transform modal component -->
    <modal :mouseDownOn="false" :show.sync="modals.modal0" size="lg" class="col-12">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Cadastro de usuários</h5>
      </template>

      <form role="form">
        <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
          <base-input rules="required" class="mb-3" label="Nome" v-model="user.name" :disabled="disabledInput"
            placeholder="Nome completo" :error="errors[0]" :max="120"></base-input>
        </ValidationProvider>
        <ValidationProvider vid="email" name="E-mail" rules="validEmail" v-slot="{ errors }">
          <base-input class="mb-3" label="Email" v-model="user.email" :disabled="disabledInput"
            placeholder="exemplo@email.com" :error="errors[0]" :max="256" rules="required"></base-input>
        </ValidationProvider>
        <div class="row">
          <div class="col-12 col-md-12 mb-2">
              <label class="form-control-label mb-3">Deseja alterar a senha?</label>
              <base-switch
                v-model="alterPassword"
                :label="alterPassword ? 'Sim' : 'Não'"
              />
            </div>
          <div class="col-12 col-sm-12 col-md-6">
            <ValidationProvider vid="password" name="password" rules="validPassword" v-slot="{ errors }">
              <PasswordInput :disabled="!alterPassword" group label="Senha" :hidden="disabledInput" v-model="user.password"
                placeholder="Senha" :error="errors[0]" :max="150" rules="required"> </PasswordInput>
            </ValidationProvider>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <ValidationProvider vid="passord_confirmation" name="passord_confirmation" rules="required"
              v-slot="{ errors }">
              <PasswordInput :disabled="!alterPassword" group label="Confirmação de senha" placeholder="Confirmar Senha"
                v-model="user.password_confirmation" :hidden="disabledInput" rules="required" :max="150"
                :error="user.password != user.password_confirmation ? 'Confirmação de senha deve coincidir com a senha' : '' || errors[0]"></PasswordInput>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <ValidationProvider vid="cpf" name="cpf" rules="validCPF" v-slot="{ errors }">
              <base-input group class="mb-3" label="CPF" v-model="user.cpf" :disabled="disabledInput" placeholder="CPF"
                mask="cpf" rules="required" :error="errors[0]"></base-input>
            </ValidationProvider>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <label class="mr-3 form-control-label">Sexo</label>
            <div class="row mt-2 ml-2">
              <base-radio name="0" inline class="mb-3" v-model="user.gender"
                :disabled="disabledInput">Masculino</base-radio>
              <base-radio name="1" inline class="mb-3" v-model="user.gender"
                :disabled="disabledInput">Feminino</base-radio>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <ValidationProvider vid="roles" name="roles" rules="required" v-slot="{ errors }">
              <base-input rules="required" label="Papel" :error="errors[0]">
                <el-select v-model="user.role_id" @change="updateIsManagerRole" filterable placeholder="Escolha um papel" :disabled="disabledInput"
                  id="ControlSelect1">
                  <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id"></el-option>
                </el-select>
              </base-input>
            </ValidationProvider>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <ValidationProvider vid="alcada" name="competence" rules="required">
              <base-input group label="Porcentagem de alçada" v-model="user.competence" :hidden="disabledInput"
                placeholder="Porcentagem de Alçada" append-icon="fa fa-percent" type="number" :max="100"></base-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <el-tooltip content="Por padrão o status do usuario é iniciado como inativo no sistema" placement="top">
              <ValidationProvider vid="status" name="status" rules="required" v-slot="{ errors }">
                <base-input rules="required" :error="errors[0]">
                  <base-switch v-model="user.status" :disabled="disabledInput" label="Status"></base-switch>
                </base-input>
              </ValidationProvider>
            </el-tooltip>
          </div>
        </div>
        <anosafra-jobs-form
          v-model="jobData"
          v-if="isManagerRole"
          :initial-data="jobsFormInitialData"
          :deletion-list.sync="anosafraToDeleteJobs"
        />
      </form>
      <template slot="footer">
        <base-button type="secondary" @click="closeRegisterModal">Fechar</base-button>
        <div v-if="jobData.length > 0 || jobsFormInitialData.length > 0">
          <el-tooltip content="Selecione ao menos um Ano Safra" placement="top" :disabled="validJobAssociation">
            <base-button 
              type="success" 
              :disabled="!validJobAssociation" 
              @click="openJobAssociationsModal"
            >
              Continuar
            </base-button>
          </el-tooltip>
        </div>
        <div v-else>
          <base-button 
            type="success" 
            @click="saveAssociations" 
            :loading="isLoadingUserRegister"
          >
            Salvar
          </base-button>
        </div>
      </template>
    </modal>

    <validation-observer v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveAssociations)" role="form">
        <modal 
          :show.sync="modals.jobData" 
          size="lg" 
          id="edit-job-associations" 
          @close="modals.jobData = false"
        >
          <template slot="header">
            <h2 class="px-4 pb-0">
              Inclusão de cargos
            </h2>
          </template>
          <job-associations-form
            @input="updateJobAssociationParams"
            :anosafra-jobs="jobData"
            :initial-data="jobsFormInitialData"
            :valid.sync="validProductData"
          />
          <template slot="footer">
            <base-button 
              type="secondary" 
              @click="modals.jobData = false"
            >
              Fechar
            </base-button>
            <el-tooltip
              placement="bottom"
              content="Preencha os dados antes de continuar!" 
              :disabled="!validProductData || isLoadingSaveAssociations"
            >
              <base-button 
                type="success" 
                native-type="submit" 
                :loading="isLoadingSaveAssociations" 
                :disabled="!validProductData || isLoadingSaveAssociations"
              >
                Salvar
              </base-button>
            </el-tooltip>
          </template>
        </modal>
      </form>
    </validation-observer>

    <div class="border-0 card-header">
      <h3 class="mb-0">Usuários Cadastrados</h3>
    </div>

    <user-table
      :users="users"
      :isLoading="isLoading"
      @view="view"
      @edit="edit"
      @remove="remove"
    />

    <div class="card-footer py-4 d-flex justify-content-end">
      <base-pagination 
        v-on:input="changePage" 
        v-model="paginated_data['current']" 
        :total="paginated_data['count']"
        :perPage="paginated_data['per_page']"
      />
    </div>
  </div>
</template>
<script>
import { ValidationProvider, extend } from "vee-validate";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import ServerSideValidation from "@/views/Forms/FormValidation/ServerSideValidation";
import UserSegmentForm from '@/components/User/UserSegmentForm.vue';
import AnosafraJobsForm from '@/components/User/AnosafraJobsForm.vue';
import PasswordInput from "@/components/Inputs/PasswordInput.vue";
import JobAssociationsForm from '@/components/User/JobAssociationsForm.vue';
import UserTable from '@/components/User/Table.vue';

import {
  Select,
  Option,
} from "element-ui";

extend('validEmail', {
  validate: value => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  },
  message: 'Por favor, insira um endereço de e-mail válido.'
});
extend('validPassword', {
  validate: value => {
    if (value.length < 8) {
      return 'A senha deve ter pelo menos 8 caracteres.';
    }

    if (!/[A-Z]/.test(value)) {
      return 'A senha deve conter pelo menos uma letra maiúscula.';
    }

    if (!/[a-z]/.test(value)) {
      return 'A senha deve conter pelo menos uma letra minúscula.';
    }

    if (!/\d/.test(value)) {
      return 'A senha deve conter pelo menos um número.';
    }

    if (!/[!@#$%^&*()_+}{":;'?/>.<,]/.test(value)) {
      return 'A senha deve conter pelo menos um caractere especial.';
    }

    return true;
  },
  message: ''
});

extend('validCPF', {
  validate: value => {
    const cleanCPF = value.replace(/[^\d]/g, '');
    if (cleanCPF.length !== 11) {
      return false;
    }
    if (/^(\d)\1+$/.test(cleanCPF)) {
      return false;
    }
    const cpfArray = cleanCPF.split('').map(Number);
    const sum = cpfArray.slice(0, 9).reduce((acc, num, i) => acc + num * (10 - i), 0);
    const mod = sum % 11;
    const firstDigit = mod < 2 ? 0 : 11 - mod;
    if (cpfArray[9] !== firstDigit) {
      return false;
    }
    const sum2 = cpfArray.slice(0, 10).reduce((acc, num, i) => acc + num * (11 - i), 0);
    const mod2 = sum2 % 11;
    const secondDigit = mod2 < 2 ? 0 : 11 - mod2;
    if (cpfArray[10] !== secondDigit) {
      return false;
    }
    return true;
  },
  message: 'CPF inválido'
});

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ValidationProvider,
    ServerSideValidation,
    Multiselect,
    UserSegmentForm,
    PasswordInput,
    AnosafraJobsForm,
    JobAssociationsForm,
    UserTable
  },

  data() {
    return {
      disabledInput: false,
      validated: false,
      filter: {},
      filtered: false,
      regions: [],
      user: {
        managers: [],
        channel_ids: [],
        job: ""
      },
      jobs: [
        { label: 'Gerente de Negócios', value: 'mkt_manager' },
        { label: 'Gerente de Sementes HF', value: 'grocery_manager', seed_manager_type: 'grocery' },
        { label: 'Gerente de Sementes cereais',  value: 'grain_manager', seed_manager_type: 'grain' },
        { label: 'Gerente de Nutrição', value: 'nutrition_manager', seed_manager_type: 'nutrition' },
        { label: 'Gerente de Irrigação', value: 'irrigation_manager', seed_manager_type: 'irrigation' },
      ],
      anosafras: [],
      anosafra: [],
      channels: [],
      products: [],
      groups: [],
      subgroups: [],
      subgroup: [],
      users: [],
      roles: [],
      errors: [],
      isLoadingSubgroups: false,
      isLoadingProducts: false,
      isLoading: false,
      loadingAnosafra: false,
      paginated_data: [],
      modals: {
        modal0: false,
        segments: false,
        jobData: false,
      },
      active: true,
      isLoadingUserRegister: false,
      isLoadingSubgroups: false,
      isLoadingSaveAssociations: false,
      selectedRole: null,
      originalUser: null,
      originalValues: {},
      segmentData: {},
      productData: [],
      selectedSubgroups: [],
      selectedGroups: [],
      productDataKey: null,
      segmentDataKey: null,
      isLoadingRegions: false,
      isLoadingRoles: false,
      loadingRemoveUser: false,
      showSpecialCharError: false,
      showUppercaseError: false,
      showLowercaseError: false,
      showNumberError: false,
      alterPassword: false,
      seedFilters: {},
      preSelectedData: {},
      jobData: [],
      validProductData: false,
      jobAssociationParams: [],
      jobsFormInitialData: [],
      anosafraToDeleteJobs: [],
      isManagerRole: false
    };
  },
  mounted() {
    this.setData();
    this.getRoles();
    this.getRegions();
    this.getAnosafras();
    this.getChannels();
  },
  methods: {
    updateIsManagerRole(value) {
      if (!value) this.isManagerRole = false;

      const selectedRole = this.roles.find(el => el.id == value)

      this.isManagerRole = selectedRole.default_to == 'manager'
    },
    updateJobAssociationParams(value) {
      const params = []

      for (const anosafraID in value) {
        for (const job in value[anosafraID]) {
          params.push({
            user_id: this.user.id,
            anosafra_id: anosafraID,
            category: job,
            ...value[anosafraID][job]
          })
        }
      }

      this.jobAssociationParams = params
    },
    resetProductSelection() {
      this.selectedGroups = {};
      this.selectedSubgroups = {};
      this.productData = {};
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    openJobAssociationsModal() {
      this.modals.jobData = true;
    },
    async setData(q = {}, page = null) {
      this.isLoading = true;

      if (typeof q === "undefined" || this.emptyFilter) q = null;
      if (page === null) page = this.currentPage;
      if (this.emptyFilter) q = null;

      try {
        const response = await this.$http.secured.get("/api/v1/users", {
          params: {
            page: page,
            latest_job: true,
            q: {
              ...q,
              status: this.active,
              ...(this.selectedRole ? { role_id: this.selectedRole.id } : {}),
            },
          },
        });

        this.paginated_data = response.data;
        this.users = this.paginated_data["users"];

        if (this.paginated_data.total_pages < page) {
          this.currentPage = 1;
        } else {
          this.currentPage = page;
        }

      } catch (error) {
        console.error("[ListUsers][SetData]", error);
      } finally {
        this.isLoading = false;
      }
    },
    search() {
      this.filtered = !this.emptyFilter;
      this.setData(this.cleanFilter(), 1);
    },
    changePage(page) {
      let filterInput = null;
      if (this.filtered) filterInput = this.filter;
      this.setData(filterInput, page);
    },
    view(user) {
      this.user          = user;
      this.disabledInput = true;
      this.modals.modal0 = true;
    },
    newUser() {
      this.user              = {};
      this.segmentData       = {};
      this.productData       = [];
      this.selectedSubgroups = [];
      this.selectedGroups    = [];
      this.disabledInput     = false;
      this.modals.modal0     = true;
    },
    edit(user) {
      this.segmentData       = {};
      this.productData       = [];
      this.selectedSubgroups = [];
      this.selectedGroups    = [];
      this.jobsFormInitialData = []
      this.isManagerRole       = false

      this.originalValues = {
        user: JSON.parse(JSON.stringify(this.user))
      };

      this.user = { ...user };
      this.disabledInput = false;
      this.user.has_coordinateds = user.has_coordinateds;
      this.user.group = user.group;
      this.getJobAssociations();
      this.updateIsManagerRole(user.role_id)
      this.modals.modal0 = true;
      this.validProductData = false;
    },
    closeRegisterModal() {
      if (this.originalValues.user) {
        this.user = JSON.parse(JSON.stringify(this.originalValues.user));
      }
      this.modals.modal0 = false;
    },
    async getRegions() {
      this.isLoadingRegions = true;
      try {
        const response = await this.$http.secured.get("/api/v1/regions")
        this.regions = response.data;
      } catch (error) {
        console.error("[ListUsers][getRegions]", error);        
      } finally {
        this.isLoadingRegions = false;
      }
    },
    async deleteAnosafraJobAssociations() {
      const params = { user_id: this.user.id, anosafra_id: this.anosafraToDeleteJobs.map( el => el.id ) }
      const response = await this.$http.secured.delete("/api/v2/job_associations/destroy_by_anosafra", { params: params });

      this.anosafraToDeleteJobs = [];
    },
    async saveAssociations() {
      this.isLoadingSaveAssociations = true;

      try {
        if (!await this.save()) return false;
        if (this.anosafraToDeleteJobs.length) await this.deleteAnosafraJobAssociations();

        this.isLoadingSaveAssociations = true;

        const params = { user_id: this.user.id }

        if (this.jobData.length) { 
          params.job_associations = this.jobAssociationParams;
        
          const response = await this.$http.secured.post("/api/v2/job_associations/upcreate", params);
        
          this.users.push(response.data);
        }

        this.error = {};

      } catch (error) {
        this.errors = error.response ? error.response.data : "Ocorreu um erro inesperado";
        console.error("[ListUsers][SaveAssociations]", this.errors);

      } finally {
        this.isLoadingSaveAssociations = false;
        this.modals.jobData = false;
      }
    },
    checkPassword() {
      this.showSpecialCharError = !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.user.password);
      this.showUppercaseError = !/[A-Z]/.test(this.user.password);
      this.showLowercaseError = !/[a-z]/.test(this.user.password);
      this.showNumberError = !/\d/.test(this.user.password);

      return (
        !this.showSpecialCharError &&
        !this.showUppercaseError &&
        !this.showLowercaseError &&
        !this.showNumberError
      );
    },
    async save() {
      if (!this.checkPassword() && this.alterPassword) {
        this.$toasted.global.defaultError({
          msg: "Por favor, corrija os erros antes de enviar.",
        });

        return false;
      }

      if (!this.validUser()) return false;

      if (this.user.id) {
        this.alterPassword = false;
        return await this.updateUser();
      }

      return await this.createUser();
    },
    async createUser() {
      this.isLoadingUserRegister = true;

      try {
        const response = await this.$http.secured.post("/api/v1/users", { user: this.user })
          
        this.users.push(response.data);
        this.$toasted.global.defaultSuccess();
        this.modals.modal0 = false;
        this.disabledInput = false;
        this.setData();
        this.$set(this.user, 'id', response.data.id);
        this.error = {};
        if (this.$currentUser().id == this.user.id) {
          let newCurrentUser = JSON.parse(localStorage.currentUser)
          newCurrentUser.competence = response.data.competence;
          localStorage.setItem('currentUser', JSON.stringify(newCurrentUser))
        }
        this.isLoadingUserRegister = false;

        return true;
      } catch (error) {
        this.errors = error.response.data;
        this.$refs.formValidator.setErrors(this.errors);
        this.isLoadingUserRegister = false;

        return false;
      } finally {
        this.isLoadingUserRegister = false;
      }
    },
    async updateUser() {
      this.isLoadingUserRegister = true;

      try {
        const response = await this.$http.secured.put(`/api/v1/users/${this.user.id}`, { user: this.user })
        
        this.response = response.data;
        this.modals.modal0 = false;
        this.$toasted.global.defaultSuccess();
        this.setData(this.cleanFilter(), this.currentPage);
        this.isLoadingUserRegister = false;
        if (this.$currentUser().id == this.user.id) {
          let newCurrentUser = JSON.parse(localStorage.currentUser)
          newCurrentUser.competence = response.data.competence;
          localStorage.setItem('currentUser', JSON.stringify(newCurrentUser))
        }

        return true;
      } catch (error) {
        this.isLoadingUserRegister = false;
        this.setError(error, "Cannot update user");
        this.$toasted.global.defaultError({
          msg: "Senha já utilizada nos últimos 90 dias",
        });

        return false;
      } finally {
        this.isLoadingUserRegister = false;
      }
    },
    validUser() {
      if (this.user.password && this.user.password.length < 8)       return false;
      if (this.user.password != this.user.password_confirmation)     return false;
      if (!this.user.name || !this.user.email || !this.user.role_id) return false;

      return true
    },
    async remove(user) {
      this.loadingRemoveUser = true;
      if (confirm("Deseja excluir o usuario " + `${user.name}` + "?")) {
        try {
          await this.$http.secured.delete(`/api/v1/users/${user.id}`, user);
          this.$toasted.global.defaultSuccess();
          this.setData();
          this.users.splice(this.users.indexOf(this.user), 1);
        } catch (error) {
          console.log("[ListUsers][removeUser]", error);
        } finally {
          this.loadingRemoveUser = false;
        }
      }
    },
    async getRoles() {
      this.isLoadingRoles = true;
      try {
        const response = await this.$http.secured.get("/api/v1/roles")
        this.roles = response.data.roles;
      } catch (error) {
        console.error("[ListUsers][getRoles]", error);
      } finally {
        this.isLoadingRoles = false;
      }
    },
    async getAnosafras() {
      this.loadingAnosafra = true;
      try {
        const response = await this.$http.secured.get(`/api/v1/anosafras`);
        this.anosafras = response.data.anosafras
      } catch (error) {
        console.error("[ListUSers][GetAnosafras]", error);
      } finally {
        this.loadingAnosafra = false;
      }
    },
    async getChannels() {
      this.isLoadingChannnels = true;
      try {
        const response = await this.$http.secured.get("/api/v1/channels");
        this.channels = response.data;
      } catch (error) {
        console.error("[ListUsers][getChannels]", error);
      } finally {
        this.isLoadingChannnels = false;
      }
    },
    async getAnosafraUsers() {
      try {
        const response = await this.$http.secured.get("/api/v1/anosafra_user", {
          params: { q: { seed_manager_id: this.user.id} }
        })

        return response.data.anosafra_users;
      } catch (error) {
        console.error("[ListUsers][GetAnosafraUsers]", error);
      }
    },
    async getJobAssociations() {
      try {
        const response = await this.$http.secured.get("/api/v2/job_associations", {
          params: { q: { user_id: this.user.id }, unpaged: true }
        })

        this.jobsFormInitialData = this.parseJobAssociations(response.data.data)

      } catch (error) {
        console.error("[ListUsers][GetAnosafraUsers]", error);
      }
    },
    parseJobAssociations(jobAssociations) {
      if (jobAssociations.length == 0) return [];
      
      const parsedData = []

      const groupedJobAssociations = Object.groupBy(jobAssociations, (el) => el.anosafra_id)

      for (let anosafraID in groupedJobAssociations) {
        parsedData.push({
          anosafra: groupedJobAssociations[anosafraID][0].anosafra,
          jobs: groupedJobAssociations[anosafraID].map(el => el.category),
          associations: groupedJobAssociations[anosafraID]
        })
      }

      return parsedData
    },
    cleanFilter() {
      const tmpObj = {}
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key]) tmpObj[key] = this.filter[key];
      })
      return tmpObj
    },
    clearSearch() {
      this.filter.name = '';
      this.selectedRole = '';
      this.search();
    },
    limitText(count) { 
      return `+ ${count}`;
    },
  },
  computed: {
    populatedJobData() {
      if (!this.jobData) return [];

      return this.jobData.filter(job => !!job.anosafra)
    },
    validJobAssociation() {
      return this.isSeedDerivedManager || this.isMktDerivedManager
    },
    emptyFilter: function () {
      for (var key in this.filter) {
        if (this.filter.hasOwnProperty(key) && this.filter[key] != "") return false;
      }

      return true;
    },
    isSeedDerivedManager() {
      const jobs = this.jobsFormInitialData.length ? this.jobsFormInitialData : this.jobData

      if (!jobs || jobs.length == 0) return false;

      return jobs.flatMap(el => el.jobs).some(job => ['grocery_manager', 'grain_manager', 'nutrition_manager', 'irrigation_manager'].includes(job))
    },
    isMktDerivedManager() {
      const jobs = this.jobsFormInitialData.length ? this.jobsFormInitialData : this.jobData

      if (!jobs || jobs.length == 0) return false;

      return jobs.flatMap(el => el.jobs).some(job => ['mkt_manager'].includes(job))
    }
  },
  watch: {
    active() {  
      this.search();
    },
  },
};
</script>

<style scoped>
.message {
  color: red;
}

.el-input__inner {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
</style>
